import React from 'react';
import type { ChipProps as MuiChipProps, SxProps } from '@mui/material';
import { Chip as MuiChip } from '@mui/material';

export type { SxProps };

export const Tag: React.FC<MuiChipProps> = (props) => {
  return <MuiChip {...props} variant="tag" />;
};
